var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4849 0.501831C17.3999 0.501831 22.1951 5.29693 22.1951 11.2121C22.1951 17.1272 17.3999 21.9223 11.4849 21.9223C5.56977 21.9223 0.774628 17.1271 0.774628 11.2121C0.774628 5.29698 5.56977 0.501831 11.4849 0.501831ZM9.22143 10.5017L5.44277 7.54666C5.41175 7.64319 5.39484 7.74614 5.39484 7.85271V14.3658L9.22143 10.5017ZM13.1035 10.8858L12.2335 11.5604C11.9876 11.751 11.6982 11.8464 11.4086 11.8464C11.1191 11.8464 10.83 11.751 10.584 11.5604L9.71405 10.8858L5.54411 15.0965C5.72083 15.3825 6.03745 15.5737 6.39718 15.5737H16.5724C16.893 15.5737 17.1791 15.4219 17.3629 15.1867L13.1035 10.8858ZM17.4953 7.46201L13.5964 10.5022L17.5749 14.5194V7.85275C17.5749 7.71428 17.5467 7.58209 17.4953 7.46201ZM6.39723 6.85045C6.17646 6.85045 5.9719 6.92252 5.80616 7.04408C7.52426 8.38773 9.23959 9.73333 10.9632 11.0696C11.0962 11.1727 11.2524 11.2244 11.4087 11.2244C11.565 11.2244 11.7215 11.1728 11.8544 11.0696C13.6019 9.71472 15.3443 8.35341 17.0879 6.99383C16.9373 6.9028 16.7608 6.85045 16.5725 6.85045H6.39723Z",
    fill: "#546EDB",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.80a32bc861a98515eeb9d60ce8060b60.svg";
export { ForwardRef as ReactComponent };